import React from 'react'
import TrackerStepIcon from '../../TrackerStepIcon'
import { truckWhite } from 'resources/images'
import StepContentRenderer from '../../StepContentRenderer'
import { convertIsoDateToDateString } from 'components/accountTracker/utils/utils'

type OrderShippedStepProps = {
  stepStatus: boolean;
  isCurrentStep?: boolean;
  trackingNumber: string;
  trackingLink?: string;
  shipDate?: string;
}

function OrderShippedStep({ stepStatus, isCurrentStep, trackingNumber, trackingLink, shipDate } : OrderShippedStepProps ) : JSX.Element {
  const getShipDate = convertIsoDateToDateString( shipDate || `` )

  // handling the copy for this step within the component because we need to dynamically create the trackingLinkUrl and trackingLinkText
  const orderShippedCopy = {
    notCompletedStepHeading: `Order Pending`,
    currentStepDetails: `Your order is confirmed and currently pending shipment from our warehouse. Your order will ship 10 days prior to your scheduled clinical set-up appointment.`,
    stepToolTip: `Once all previous steps are complete, we will get your order shipped out!`,
    completedStepHeading: `Order Shipped`,
    completedStepDetails: shipDate ? `Date of Shipment: ${getShipDate.date}` : ``,
    completedStepLinkText: trackingNumber ? `Tracking Number: # ${trackingNumber}` : ``,
    completedStepLinkUrl: trackingLink || ``
  }

  return (
    <div className="flex flex-wrap">
      <TrackerStepIcon
        imageSrc={truckWhite}
        stepStatus={stepStatus}
        isCurrentStep={isCurrentStep}
      />
      <StepContentRenderer
        stepStatus={stepStatus}
        isCurrentStep={isCurrentStep}
        stepCopy={orderShippedCopy}
      />
    </div>
  )
}

export default OrderShippedStep